import * as tslib_1 from "tslib";
import { ChangeDetectorRef, ElementRef, EventEmitter, OnInit, ViewContainerRef } from '@angular/core';
import { util } from '../../../classes/util';
import { ESRI } from '../../../esri-loader-util';
import { BooleanConverter, NumberConverter } from '../../../inputConverter';
import { GisToolsService } from '../../../services/gis-tools.service';
import { IsleService } from '../../../services/isle.service';
import { BaseComponent } from '../../base.component';
import { SegmentData } from './isle.model';
var Graphic;
var Point;
var SpatialReference;
/* tslint:disable:template-cyclomatic-complexity */
var IsleComponent = /** @class */ (function (_super) {
    tslib_1.__extends(IsleComponent, _super);
    function IsleComponent(_vcr, changeDetectorRef, isleService, gisToolsService) {
        var _this = _super.call(this, _vcr) || this;
        _this.changeDetectorRef = changeDetectorRef;
        _this.isleService = isleService;
        _this.gisToolsService = gisToolsService;
        _this._active = false;
        _this._centerMapZoomLevel = 10;
        _this._enableAutoZoomLevel = true;
        _this._moveMapOnClick = true;
        _this._includeToolbarButtons = true;
        _this._includeSegmentSection = true;
        _this._includeScaleSection = false;
        _this._mileMarkerDescription = '';
        _this._showStreetNames = false;
        _this.activeChange = new EventEmitter();
        _this.showSelect = false;
        _this.templateOptions = [];
        _this.selectedTemplate = 'PAVEMENT HISTORY';
        // Isle Properties
        _this.segmentData = null;
        _this.options = {
            crsTolerance: 24
        };
        _this._county = null;
        _this._route = null;
        _this.globalSegment = '';
        _this._segment = null;
        _this._lat = '';
        _this._long = '';
        _this.segmentInfo = null;
        _this._username = '';
        _this.tolerance = 100;
        //usecrsforislebot checks if county, route and segment is provided as input for ISLE bot. crs is county, route,segment.
        _this._usecrsforislebot = false;
        _this._appEnvironment = '';
        _this._enableMapClick = true;
        _this.newsegmentevent = new EventEmitter();
        _this.selectedTemplateChanged = new EventEmitter();
        _this.registerEvent('activeChange', _this.activeChange);
        _this.registerEvent('newsegmentevent', _this.newsegmentevent);
        _this.registerEvent('selectedTemplateChanged', _this.selectedTemplateChanged);
        return _this;
    }
    Object.defineProperty(IsleComponent.prototype, "active", {
        set: function (value) {
            this._active = BooleanConverter(value);
            this._active ? this.activate() : this.deactivate();
            this.activeChange.emit(this._active);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IsleComponent.prototype, "centerMapZoomLevel", {
        get: function () {
            return this._centerMapZoomLevel;
        },
        set: function (value) {
            this._centerMapZoomLevel = NumberConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IsleComponent.prototype, "enableAutoZoomLevel", {
        get: function () {
            return this._enableAutoZoomLevel;
        },
        set: function (value) {
            this._enableAutoZoomLevel = BooleanConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IsleComponent.prototype, "pointSymbol", {
        set: function (symbol) {
            this._pointSymbol = symbol;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IsleComponent.prototype, "lineSymbol", {
        set: function (symbol) {
            this._lineSymbol = symbol;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IsleComponent.prototype, "moveMapOnClick", {
        set: function (value) {
            this._moveMapOnClick = BooleanConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IsleComponent.prototype, "includeToolbarButtons", {
        set: function (value) {
            this._includeToolbarButtons = BooleanConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IsleComponent.prototype, "includeSegmentSection", {
        get: function () {
            return this._includeSegmentSection;
        },
        set: function (value) {
            this._includeSegmentSection = BooleanConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IsleComponent.prototype, "includeScaleSection", {
        get: function () {
            return this._includeScaleSection;
        },
        set: function (value) {
            this._includeScaleSection = BooleanConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IsleComponent.prototype, "mileMarkerDescription", {
        get: function () {
            return this._mileMarkerDescription;
        },
        set: function (value) {
            if (value) {
                this._mileMarkerDescription = " {    MM -   " + value + "   }";
            }
            else {
                this._mileMarkerDescription = '';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IsleComponent.prototype, "showStreetNames", {
        get: function () {
            return this._showStreetNames;
        },
        set: function (value) {
            this._showStreetNames = BooleanConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IsleComponent.prototype, "county", {
        get: function () {
            return this._county;
        },
        set: function (county) {
            this._county = county;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IsleComponent.prototype, "route", {
        get: function () {
            return this._route;
        },
        set: function (route) {
            this._route = route;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IsleComponent.prototype, "segment", {
        get: function () {
            return this._segment;
        },
        set: function (segment) {
            this._segment = segment;
            this.globalSegment = segment;
            this.loadIsleSegment();
            this.changeDetectorRef.detectChanges();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IsleComponent.prototype, "lat", {
        get: function () {
            return this._lat;
        },
        set: function (value) {
            this._lat = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IsleComponent.prototype, "long", {
        get: function () {
            return this._long;
        },
        set: function (value) {
            this._long = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IsleComponent.prototype, "username", {
        get: function () {
            return this._username;
        },
        set: function (value) {
            this._username = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IsleComponent.prototype, "usecrsforislebot", {
        get: function () {
            return this._usecrsforislebot;
        },
        set: function (value) {
            this._usecrsforislebot = BooleanConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IsleComponent.prototype, "appEnvironment", {
        get: function () {
            return this._appEnvironment;
        },
        set: function (value) {
            this._appEnvironment = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IsleComponent.prototype, "enableMapClick", {
        get: function () {
            return this._enableMapClick;
        },
        set: function (value) {
            this._enableMapClick = BooleanConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    IsleComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, err_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, 3, 4]);
                        _a = this;
                        return [4 /*yield*/, this.setupMapViewRef(this.mapRef)];
                    case 1:
                        _a.mapRef = _b.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        err_1 = _b.sent();
                        this.readyProblem(err_1);
                        return [3 /*break*/, 4];
                    case 3:
                        this.isReady();
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    IsleComponent.prototype.loadIsleSegment = function () {
        if (this.usecrsforislebot) {
            if (this.username) {
                this.getTemplateByUser(this.username, this.appEnvironment);
            }
            this.getSegmentDataForISLE();
            this.changeDetectorRef.detectChanges();
        }
    };
    IsleComponent.prototype.getTemplateByUser = function (username, appEnvironment) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result, updatedOptions, finalOptions;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.isleService.getTemplates(username, appEnvironment)];
                    case 1:
                        result = _a.sent();
                        updatedOptions = result;
                        finalOptions = [];
                        /*only displays one template name if there are duplicate names of templates since
                            original has id of ISLE_SYSTEM and custom made templates have user's username*/
                        updatedOptions.forEach(function (template) {
                            //checks that userid is a personal profile and not default system
                            if (template.userId === username && template.userId !== 'ISLE_SYSTEM') {
                                updatedOptions.forEach(function (template2, index2) {
                                    //removes the duplicate option from template list
                                    if (template.name === template2.name && template.userId !== template2.userId) {
                                        updatedOptions.splice(index2, 1);
                                    }
                                });
                            }
                        });
                        //populates array order to be displayed in dropdown
                        //checks if user is signed in
                        if (username.length > 0 && username !== 'ISLE_SYSTEM') {
                            //adds first option with empty vaule as empty placeholder
                            finalOptions.push(updatedOptions[0]);
                            //if the user has a template set as default, it will get added second
                            updatedOptions.forEach(function (template) {
                                if (template.isDefault && template.userId !== 'ISLE_SYSTEM') {
                                    finalOptions.push(template);
                                    //sets default template to be selected by default only if selected is pavement history
                                    //will stay as pavement history if already is, or will change default
                                    //need if statement so doesn't reset selected everytime a new segment is loaded
                                    if (_this.selectedTemplate === 'PAVEMENT HISTORY') {
                                        _this.selectedTemplate = template.name;
                                    }
                                }
                            });
                            /*if the above statement didn't populate a second template (meaning no default template selected)
                                    then will push normal second template*/
                            if (finalOptions.length === 1) {
                                finalOptions.push(updatedOptions[1]);
                            }
                            //will push all remaining templates to array
                            updatedOptions.forEach(function (template) {
                                if (template.name !== finalOptions[0].name && template.name !== finalOptions[1].name) {
                                    finalOptions.push(template);
                                }
                            });
                        }
                        else {
                            //if user is not signed in
                            updatedOptions.forEach(function (template) {
                                finalOptions.push(template);
                            });
                        }
                        //populates global array used by dropdown
                        this.templateOptions = finalOptions.map(function (t) { return t.name; });
                        return [2 /*return*/];
                }
            });
        });
    };
    IsleComponent.prototype.getSegmentDataForISLE = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.getSegmentData();
                this.includeSegmentSection = true;
                this.showSelect = true;
                return [2 /*return*/];
            });
        });
    };
    /**
     * Make the tool active/shown.
     */
    IsleComponent.prototype.activate = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadESRIClasses()];
                    case 1:
                        _a.sent();
                        this.getTemplateByUser(this.username, this.appEnvironment);
                        if (!(!this.mapClickListener && this.enableMapClick)) return [3 /*break*/, 5];
                        _a.label = 2;
                    case 2:
                        if (!!this.mapRef) return [3 /*break*/, 4];
                        return [4 /*yield*/, util.sleep(10)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 2];
                    case 4:
                        this.mapClickListener = this.mapRef.on('click', function (evt) { return _this.handleMapClick(evt); });
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Make the tool inactive/hidden.
     */
    IsleComponent.prototype.deactivate = function () {
        if (this.mapClickListener) {
            this.mapClickListener.remove();
            this.mapClickListener = null;
        }
        if (this.lineGraphic) {
            this.mapRef.graphics.remove(this.lineGraphic);
        }
    };
    IsleComponent.prototype.loadESRIClasses = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(!Point || !Graphic || !SpatialReference)) return [3 /*break*/, 2];
                        return [4 /*yield*/, Promise.all([
                                ESRI.Point,
                                ESRI.Graphic,
                                ESRI.SpatialReference
                            ])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 3]), Point = _a[0], Graphic = _a[1], SpatialReference = _a[2];
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    IsleComponent.prototype.handleMapClick = function (evt) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!evt.mapPoint) return [3 /*break*/, 3];
                        this.selectedPoint = evt.mapPoint;
                        // this.options.crsTolerance = this.utilityService.getSearchRadiusTolerance(this.map.getZoom());
                        this.lat = this.selectedPoint.latitude.toString();
                        this.long = this.selectedPoint.longitude.toString();
                        return [4 /*yield*/, this.getCSR(this.lat, this.long)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.getSegmentData()];
                    case 2:
                        _a.sent();
                        this.addPoint(this.selectedPoint.longitude, this.selectedPoint.latitude);
                        this.drawSegment();
                        this.showSelect = true;
                        this.changeDetectorRef.detectChanges();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    IsleComponent.prototype.getSegmentData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, segmentData, segmentsData;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.segment) return [3 /*break*/, 2];
                        return [4 /*yield*/, Promise.all([
                                this.isleService.getSegment(this.county, this.route, this.segment, this.selectedTemplate, this.username, this.usecrsforislebot, this.appEnvironment),
                                this.isleService.getSegments(this.county, this.route)
                            ])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 2]), segmentData = _a[0], segmentsData = _a[1];
                        this.segmentData = new SegmentData(segmentData);
                        this.selectedSegment = this.segmentData.segments[0];
                        if (typeof this.selectedSegment !== 'undefined') {
                            this.segmentData.sideIndicator = this.selectedSegment.sideIndicator;
                        }
                        this.setSegmentData(this.selectedSegment, segmentsData);
                        _b.label = 2;
                    case 2:
                        this.changeDetectorRef.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    IsleComponent.prototype.getCSR = function (lat, long, tolerance) {
        if (tolerance === void 0) { tolerance = null; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var segments;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gisToolsService.getSegmentsNearLatLong(lat, long, tolerance || this.tolerance)];
                    case 1:
                        segments = _a.sent();
                        if (segments.length) {
                            this.county = segments[0].countyCode;
                            this.segment = segments[0].segmentNumber;
                            this.route = segments[0].stateRouteNumber;
                            this.globalSegment = this.segment;
                            this.segmentChanged(this.segment);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    IsleComponent.prototype.segmentChanged = function (newSegment) {
        this.newsegmentevent.emit(newSegment);
    };
    IsleComponent.prototype.setSegmentData = function (segment, segments) {
        // Find previous segment to this one if it exists.
        segment.prev = segments.reduce(function (acc, s) {
            if (s.sideIndicator === segment.sideIndicator && s.segmentNumber < segment.segmentNumber && (!acc || s.segmentNumber > acc.segmentNumber)) {
                return s;
            }
            return acc;
        }, null);
        // Find next segment if it exists.
        segment.next = segments.reduce(function (acc, s) {
            if (s.sideIndicator === segment.sideIndicator && s.segmentNumber > segment.segmentNumber && (!acc || s.segmentNumber < acc.segmentNumber)) {
                return s;
            }
            return acc;
        }, null);
        // Find segment on opposite side of the road if it exists.
        segment.otherSide = segments.find(function (s, index) {
            // Segment at 'index' is is otherSide if, based on sideIndicator,
            // the previous/next segment is our selected segment.
            var checkSegment = segments[segment.sideIndicator === '1' ? index - 1 : index + 1];
            var otherSideSegs = checkSegment && s.sideIndicator !== checkSegment.sideIndicator && checkSegment.segmentNumber === segment.segmentNumber;
            return otherSideSegs;
        });
        this.changeDetectorRef.detectChanges();
    };
    IsleComponent.prototype.addPoint = function (long, lat) {
        if (this.active && this.mapRef) {
            if (this.pointGraphic) {
                this.mapRef.graphics.remove(this.pointGraphic);
            }
            var point = new Point({
                longitude: parseFloat(long),
                latitude: parseFloat(lat)
            });
            this.centerPoint = point;
            this.pointGraphic = new Graphic({
                geometry: point,
                symbol: this._pointSymbol
            });
            this.mapRef.graphics.add(this.pointGraphic);
            if (this._moveMapOnClick) {
                if (this.mapRef.zoom < this.centerMapZoomLevel && this.enableAutoZoomLevel) {
                    this.mapRef.goTo({
                        center: this.centerPoint,
                        zoom: this.centerMapZoomLevel
                    });
                }
                else {
                    this.mapRef.goTo({
                        center: this.centerPoint
                    });
                }
            }
            this.changeDetectorRef.detectChanges();
        }
    };
    IsleComponent.prototype.drawSegment = function () {
        var e_1, _a;
        if (this.selectedSegment) {
            if (this.lineGraphic) {
                this.mapRef.graphics.remove(this.lineGraphic);
            }
            var points = [];
            var latLongs = this.selectedSegment.latLongs.split(';');
            try {
                for (var latLongs_1 = tslib_1.__values(latLongs), latLongs_1_1 = latLongs_1.next(); !latLongs_1_1.done; latLongs_1_1 = latLongs_1.next()) {
                    var latLong = latLongs_1_1.value;
                    var parts = latLong.split(',');
                    points.push([parseFloat(parts[1]), parseFloat(parts[0])]);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (latLongs_1_1 && !latLongs_1_1.done && (_a = latLongs_1.return)) _a.call(latLongs_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            var polyline = {
                type: 'polyline',
                paths: points,
                spatialReference: null
            };
            this.lineGraphic = new Graphic({
                geometry: polyline,
                symbol: this._lineSymbol
            });
            this.mapRef.graphics.add(this.lineGraphic);
            // this.centerPoint = graphic.geometry.extent.center;
            this.mapRef.goTo({
                center: this.centerPoint
            });
        }
    };
    IsleComponent.prototype.updateSegment = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.usecrsforislebot) return [3 /*break*/, 3];
                        this.lat = this.selectedPoint.latitude.toString();
                        this.long = this.selectedPoint.longitude.toString();
                        return [4 /*yield*/, this.getCSR(this.lat, this.long)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.getSegmentData()];
                    case 2:
                        _a.sent();
                        this.addPoint(this.selectedPoint.longitude, this.selectedPoint.latitude);
                        this.drawSegment();
                        this.changeDetectorRef.detectChanges();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.getSegmentData()];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    IsleComponent.prototype.templateChanged = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.updateSegment();
                this.selectedTemplateChanged.emit(this.selectedTemplate);
                return [2 /*return*/];
            });
        });
    };
    IsleComponent.prototype.selectItemDetails = function (event, item) {
        this.selectedAttributeItem = item;
        this.itemDetailsOpen = true;
        this.changeDetectorRef.detectChanges();
        // Need to set location after displaying otherwise secondaryDiv size isn't calculated
        // (event.page_ - event._) accounts for amount scrolled
        // Display to left/right of click location depending on location of click in relation to size of container
        var primaryDivContainer = this.primaryDiv.nativeElement.getBoundingClientRect();
        var leftPosition = event.pageX < (primaryDivContainer.right / 2)
            ? event.clientX
            : event.screenX - (event.screenX - event.clientX + this.secondaryDiv.nativeElement.clientWidth) + (event.pageX - event.x);
        this.secondaryDiv.nativeElement.style.left = leftPosition + "px";
        this.secondaryDiv.nativeElement.style.top = event.screenY - (event.screenY - event.clientY + this.secondaryDiv.nativeElement.clientHeight) + (event.pageY - event.y) + "px";
    };
    IsleComponent.prototype.hideItemDetails = function () {
        this.selectedAttributeItem = null;
        this.itemDetailsOpen = false;
        this.changeDetectorRef.detectChanges();
    };
    IsleComponent.prototype.changeSegment = function (segment) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var latLongs, midPt;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.mileMarkerDescription = '';
                        latLongs = segment.latLongs.split(';');
                        midPt = util.getMiddleItem(latLongs);
                        if (midPt) {
                            this.lat = midPt.split(',')[0];
                            this.long = midPt.split(',')[1];
                        }
                        else {
                            this.lat = '';
                            this.long = '';
                        }
                        if (!!this.usecrsforislebot) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.getCSR(this.lat, this.long, 5)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.getSegmentData()];
                    case 2:
                        _a.sent();
                        this.drawSegment();
                        this.addPoint(parseFloat(this.long), parseFloat(this.lat));
                        return [3 /*break*/, 4];
                    case 3:
                        this.segment = segment.segmentNumber;
                        this.segmentChanged(this.segment);
                        _a.label = 4;
                    case 4:
                        this.changeDetectorRef.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    IsleComponent.prototype.switchSides = function (segment) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.selectedSegment = segment;
                        return [4 /*yield*/, this.changeSegment(segment)];
                    case 1:
                        _a.sent();
                        this.changeDetectorRef.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    return IsleComponent;
}(BaseComponent));
export { IsleComponent };
